<template>
  <div class="user-info-container">
    <div class="user-info-title">个人信息</div>
    <div class="user-info-main">
      <!-- 左侧个人信息 -->
      <div class="user-info-left" v-loading="loading">
        <el-descriptions :column="1" border label-class-name="info-label" content-class-name="info-content">
          <el-descriptions-item label="姓名">{{ staffInfo.name }}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{ staffInfo.tel }}</el-descriptions-item>
          <el-descriptions-item label="邮箱">{{ staffInfo.email }}</el-descriptions-item>
          <el-descriptions-item label="性别">{{ staffInfo.sex == '0' ? '男' : '女' }}</el-descriptions-item>
          <el-descriptions-item label="地址">{{ staffInfo.address }}</el-descriptions-item>
          <el-descriptions-item label="所属组织">{{ orgNames }}</el-descriptions-item>
          <el-descriptions-item label="角色">
            <div v-for="(role, index) in staffInfo.roles" :key="index">
              {{ role.roleName }}
              <span v-if="role.roleCommunityDtoList && role.roleCommunityDtoList.length > 0">
                ({{ getCommunityNames(role.roleCommunityDtoList) }})
              </span>
            </div>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      
      <!-- 右侧签名区域 -->
      <div class="user-info-right">
        <div class="signature-section">
          <div class="signature-title">当前签名</div>
          <div class="signature-preview">
            <img v-if="currentSignature" :src="currentSignature" alt="当前签名" />
            <span v-else class="no-signature">暂无签名</span>
          </div>
          <div class="signature-actions">
            <el-button type="primary" @click="openSignatureDialog">编辑签名</el-button>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 签名弹窗 -->
    <el-dialog title="手写签名" :visible.sync="signatureDialogVisible" width="860px">
      <div class="signature-dialog-content">
        <div class="signature-canvas-wrapper">
          <canvas 
            ref="signatureCanvas" 
            class="signature-canvas"
            @mousedown="startDrawing"
            @mousemove="draw"
            @mouseup="stopDrawing"
            @mouseleave="stopDrawing"
          ></canvas>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="clearSignature">清除</el-button>
        <el-button @click="triggerUpload">上传签名</el-button>
        <el-button @click="signatureDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saveLoading" @click="saveSignature">保存签名</el-button>
        <input
          ref="signatureFileInput"
          type="file"
          accept="image/*"
          style="display: none"
          @change="handleSignatureUpload"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getStaffDetail, getStaffOrgs, getStaffRoles } from '@/api/staff/staffDetailApi'
import { uploadImage, updateUserSignPic, getSignPic } from '@/api/user/userInfoApi'

export default {
  name: 'UserInfoManage',
  data() {
    return {
      loading: false,
      saveLoading: false,
      staffInfo: {
        staffId: '',
        userName: '',
        name: '',
        tel: '',
        email: '',
        sex: '',
        address: '',
        orgs: [],
        roles: []
      },
      // 签名相关
      currentSignature: '',
      signatureDialogVisible: false,
      isDrawing: false,
      ctx: null
    }
  },
  computed: {
    orgNames() {
      return this.staffInfo.orgs.map(org => org.orgName).join('、')
    }
  },
  mounted() {
    this.loadUserInfo()
  },
  methods: {
    getCommunityNames(list) {
      return list.map(item => item.communityName).join('、')
    },
    async loadUserInfo() {
      const userStr = localStorage.getItem('user')
      if (!userStr) return
      
      try {
        const user = JSON.parse(userStr)
        if (!user.userId) return
        
        this.loading = true
        const staffId = user.userId
        
        // 获取员工基本信息
        const res = await getStaffDetail({ staffId, page: 1, row: 1 })
        if (res.staffs && res.staffs.length > 0) {
          const data = res.staffs[0]
          this.staffInfo.staffId = data.staffId || ''
          this.staffInfo.userName = data.userName || ''
          this.staffInfo.name = data.name || ''
          this.staffInfo.tel = data.tel || ''
          this.staffInfo.email = data.email || ''
          this.staffInfo.sex = data.sex || ''
          this.staffInfo.address = data.address || ''
        }
        
        // 获取组织信息
        const orgRes = await getStaffOrgs({ staffId, page: 1, row: 100 })
        if (orgRes.code === 0 && orgRes.data) {
          this.staffInfo.orgs = orgRes.data
        }
        
        // 获取角色信息
        const roleRes = await getStaffRoles({ staffId, page: 1, row: 100 })
        if (roleRes.code === 0 && roleRes.data) {
          this.staffInfo.roles = roleRes.data
        }
        
        // 获取签名图片
        await this.loadSignature(user.userId)
        
      } catch (e) {
        console.log('获取用户信息失败:', e)
      } finally {
        this.loading = false
      }
    },
    
    // 加载签名图片
    async loadSignature(userId) {
      try {
        const signRes = await getSignPic({ userId })
        if (signRes.data && signRes.data.signPic) {
          this.currentSignature = signRes.data.signPic
        }
      } catch (error) {
        // 如果没有签名或获取失败，不显示错误提示
        console.log('未获取到签名图片:', error.message)
      }
    },
    // 打开签名弹窗
    openSignatureDialog() {
      this.signatureDialogVisible = true
      this.$nextTick(() => {
        this.initCanvas()
      })
    },
    // 初始化画布
    initCanvas() {
      const canvas = this.$refs.signatureCanvas
      if (canvas) {
        canvas.width = 800
        canvas.height = 420
        this.ctx = canvas.getContext('2d')
        this.ctx.strokeStyle = '#000'
        this.ctx.lineWidth = 3
        this.ctx.lineCap = 'round'
        this.ctx.lineJoin = 'round'
        // 填充白色背景
        this.ctx.fillStyle = '#fff'
        this.ctx.fillRect(0, 0, canvas.width, canvas.height)
      }
    },
    // 开始绘制
    startDrawing(e) {
      this.isDrawing = true
      const rect = this.$refs.signatureCanvas.getBoundingClientRect()
      this.ctx.beginPath()
      this.ctx.moveTo(e.clientX - rect.left, e.clientY - rect.top)
    },
    // 绘制中
    draw(e) {
      if (!this.isDrawing) return
      const rect = this.$refs.signatureCanvas.getBoundingClientRect()
      this.ctx.lineTo(e.clientX - rect.left, e.clientY - rect.top)
      this.ctx.stroke()
    },
    // 停止绘制
    stopDrawing() {
      this.isDrawing = false
    },
    // 清除签名
    clearSignature() {
      const canvas = this.$refs.signatureCanvas
      this.ctx.fillStyle = '#fff'
      this.ctx.fillRect(0, 0, canvas.width, canvas.height)
    },
    // 触发上传签名
    triggerUpload() {
      this.$refs.signatureFileInput.click()
    },
    // 处理签名上传
    handleSignatureUpload(event) {
      const file = event.target.files[0]
      if (!file) return

      const reader = new FileReader()
      reader.onload = (e) => {
        const img = new Image()
        img.onload = () => {
          const canvas = this.$refs.signatureCanvas
          // 清空画布
          this.ctx.fillStyle = '#fff'
          this.ctx.fillRect(0, 0, canvas.width, canvas.height)
          // 计算缩放比例使图片适应画布
          const scale = Math.min(canvas.width / img.width, canvas.height / img.height)
          const x = (canvas.width - img.width * scale) / 2
          const y = (canvas.height - img.height * scale) / 2
          this.ctx.drawImage(img, x, y, img.width * scale, img.height * scale)
        }
        img.src = e.target.result
      }
      reader.readAsDataURL(file)
      // 清空input值以便重复选择同一文件
      event.target.value = ''
    },
    // 保存签名
    async saveSignature() {
      try {
        this.saveLoading = true
        
        // 1. 获取canvas的base64数据
        const canvas = this.$refs.signatureCanvas
        const base64Data = canvas.toDataURL('image/png')
        
        // 2. 将base64转换为Blob
        const blob = this.base64ToBlob(base64Data)
        
        // 3. 创建File对象
        const file = new File([blob], `signature_${Date.now()}.png`, { type: 'image/png' })
        
        // 4. 创建FormData并上传图片
        const formData = new FormData()
        formData.append('uploadFile', file)
        formData.append('communityId', '-1')
        
        const uploadRes = await uploadImage(formData)
        
        // 5. 获取图片URL（兼容不同的返回格式）
        const picUrl = uploadRes.url || (uploadRes.data && uploadRes.data.url)
        
        if (!picUrl) {
          throw new Error('上传失败，未获取到图片地址')
        }
        
        // 6. 获取当前用户ID
        const userStr = localStorage.getItem('user')
        if (!userStr) {
          throw new Error('未获取到用户信息')
        }
        const user = JSON.parse(userStr)
        
        // 7. 调用更新签名接口
        await updateUserSignPic({
          userId: user.userId,
          signPic: picUrl
        })
        
        // 8. 更新本地显示
        this.currentSignature = picUrl
        this.signatureDialogVisible = false
        
        this.$message.success('签名保存成功')
      } catch (error) {
        console.log('保存签名失败:', error)
        this.$message.error(error.message || '保存签名失败，请重试')
      } finally {
        this.saveLoading = false
      }
    },
    
    // 将base64转换为Blob
    base64ToBlob(base64Data) {
      const parts = base64Data.split(';base64,')
      const contentType = parts[0].split(':')[1]
      const raw = window.atob(parts[1])
      const rawLength = raw.length
      const uInt8Array = new Uint8Array(rawLength)
      
      for (let i = 0; i < rawLength; i++) {
        uInt8Array[i] = raw.charCodeAt(i)
      }
      
      return new Blob([uInt8Array], { type: contentType })
    }
  }
}
</script>

<style lang="scss" scoped>
.user-info-container {
  width: 97%;
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  .user-info-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
    text-align: center;
  }

  .user-info-main {
    display: flex;
    gap: 60px;
    justify-content: center;
  }

  .user-info-left {
    width: 500px;
    flex-shrink: 0;
  }

  .user-info-right {
    flex-shrink: 0;
    
    .signature-section {
      text-align: center;
      
      .signature-title {
        font-size: 14px;
        font-weight: bold;
        color: #333;
        margin-bottom: 15px;
      }
      
      .signature-preview {
        width: 450px;
        height: 240px;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fafafa;
        
        img {
          max-width: 100%;
          max-height: 100%;
        }
        
        .no-signature {
          color: #909399;
          font-size: 14px;
        }
      }
      
      .signature-actions {
        margin-top: 15px;
      }
    }
  }
}

.signature-dialog-content {
  .signature-canvas-wrapper {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    display: inline-block;
  }
  
  .signature-canvas {
    display: block;
    cursor: crosshair;
    background-color: #fff;
  }
}
</style>

